import { ParameterProps } from './parameterSelector';
import { TextField } from '@mui/material';
import { ChangeEvent, useEffect } from 'react';
import { ParameterValidatorService } from './parameterValidatorService';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../locales/i18n';

type Props = ParameterProps & {
  range: number[];
  value: number;
};

const IntParameter = ({ parameter, type, name_de, name_en, selected, onChange, range, value }: Props): JSX.Element => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;

  let printValue: number | string = (selected ?? value ?? range[0] ?? 0) as number;
  if (isNaN(printValue)) {
    printValue = '';
  }
  useEffect(() => {
    if (printValue !== selected) {
      onChange(printValue);
    }
  });

  const error = ParameterValidatorService.validateInt({ type, parameter, range }, selected);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(parseInt(e.target.value));
  return (
    <TextField
      error={error !== undefined}
      label={`${currentLanguage === 'de' ? name_de : name_en} ${t('integer out of')} [${range[0] ?? '-inf'}, ${range[1] ?? 'inf'}]`}
      type={'number'}
      variant={'filled'}
      InputLabelProps={{
        shrink: true,
      }}
      fullWidth
      value={printValue}
      onChange={handleChange}
      helperText={error ? t(error) : undefined}
    />
  );
};

export default IntParameter;
